import { render, staticRenderFns } from "./ViewSystemPage.vue?vue&type=template&id=5899bf62&"
import script from "./ViewSystemPage.vue?vue&type=script&lang=js&"
export * from "./ViewSystemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports